import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../components/navbar";

const OpenVoucherSuccess = () => {
  const params = new URLSearchParams(window.location.search);
  const openVoucherId = params.get("openVoucherId");
  const paymentId = params.get("paymentId");
  const [voucher, setVoucher] = useState(null);

  useEffect(() => {
    const fetchVoucher = async () => {
      if (!openVoucherId) return;
      try {
        const query = paymentId ? `?paymentId=${paymentId}` : "";
        const res = await axios.get(
          `${process.env.REACT_APP_URI}/v1/open-vouchers/${openVoucherId}${query}`
        );
        setVoucher(res.data);
      } catch (err) {
        console.error("No se pudo cargar el voucher", err);
      }
    };
    fetchVoucher();
  }, [openVoucherId, paymentId]);

  // SEGURIDAD: Solo generar PDF si hay paymentId
  const pdfLink = openVoucherId && paymentId
    ? `${process.env.REACT_APP_URI}/v1/open-vouchers/${openVoucherId}/pdf?paymentId=${paymentId}`
    : "#";
  const expiryDate =
    voucher?.expiryDate &&
    new Date(voucher.expiryDate)
      .toLocaleDateString("es-ES")
      .replace(/\//g, "-");

  const vouchersList = voucher?.redeemedVouchers?.length
    ? voucher.redeemedVouchers
    : voucher
      ? [{
        code: voucher.code,
        tracker: voucher.tracker,
        seatsQty: voucher.seatsPerVoucher || 2,
        expiryDate: voucher.expiryDate,
      }]
      : [];

  const seatsPerVoucher = voucher?.seatsPerVoucher || vouchersList[0]?.seatsQty || 2;
  const vouchersCount = vouchersList.length || 1;
  // SEGURIDAD: Solo generar PDF si hay paymentId
  const pdfLinkBase = openVoucherId && paymentId
    ? `${process.env.REACT_APP_URI}/v1/open-vouchers/${openVoucherId}/pdf?paymentId=${paymentId}`
    : "#";

  const isGift = voucher?.isGift;
  // Si no hay paymentId, solo indicar que se envió por email
  const introText = !paymentId
    ? (isGift
      ? "Enviamos el bono al destinatario por email."
      : "Te enviamos el bono por email.")
    : (isGift
      ? "Enviamos el bono al destinatario. También puedes descargarlo aquí mismo."
      : "Te enviamos el bono por email. También puedes descargarlo aquí mismo.");

  const giftName = voucher?.buyer?.giftName || voucher?.giftName;
  const giftEmail = voucher?.buyer?.giftEmail || voucher?.giftEmail;
  const giftMessage = voucher?.buyer?.message || voucher?.message;

  return (
    <div className="position-relative">
      <Navbar />
      <section className="col-11 col-lg-8 mx-auto my-5 text-center">
        <h1 className="mb-3">
          {isGift ? "¡Bono regalo enviado!" : "¡Bono generado con éxito!"}
        </h1>
        <p className="mb-4">
          {introText}
        </p>
        <div className="card shadow border-0 p-4 mb-4">
          <h4 className="mb-2">{voucher?.name || "Bono Muérdete"}</h4>
          <p className="text-muted mb-2">
            {vouchersCount} bono(s) · {seatsPerVoucher} personas cada uno
          </p>
          {vouchersList.map((v, idx) => {
            const exp =
              v.expiryDate &&
              new Date(v.expiryDate)
                .toLocaleDateString("es-ES")
                .replace(/\//g, "-");
            return (
              <div key={`${v.code}-${idx}`} className="mb-3 p-3 border rounded">
                <p className="mb-1 fw-bold">Bono {idx + 1}</p>
                <p className="text-muted mb-1">
                  Código: <strong>{v.code}</strong>
                </p>
                <p className="text-muted mb-1">
                  Localizador:{" "}
                  <strong>
                    {v.tracker || v.localizador || "No disponible"}
                  </strong>
                </p>
                <p className="text-muted mb-0">
                  Cantidad: <strong>{v.seatsQty || seatsPerVoucher} personas</strong>
                </p>
                {exp && (
                  <p className="text-danger mb-0">
                    Válido hasta: <strong>{exp}</strong>
                  </p>
                )}
                {paymentId && (
                  <div className="mt-2">
                    <a
                      className="btn btn-outline-primary btn-sm"
                      href={`${pdfLinkBase}&code=${v.code}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Descargar PDF de este bono
                    </a>
                  </div>
                )}
              </div>
            );
          })}
          {isGift && (
            <>
              {giftName && (
                <p className="mb-1">
                  Para: <strong>{giftName}</strong>
                </p>
              )}
              {giftEmail && (
                <p className="mb-1">
                  Email destinatario: <strong>{giftEmail}</strong>
                </p>
              )}
              {giftMessage && (
                <p className="mb-3 fst-italic text-muted">“{giftMessage}”</p>
              )}
            </>
          )}
        </div>
        <div className="d-flex flex-column flex-md-row gap-3 justify-content-center">
          {paymentId && (
            <a
              className="btn btn-primary px-4 py-2 fw-bold"
              href={pdfLink}
              target="_blank"
              rel="noreferrer"
            >
              Descargar bono (PDF)
            </a>
          )}
          <a className="btn btn-outline-secondary px-4 py-2" href="/">
            Volver al inicio
          </a>
        </div>
      </section>
    </div>
  );
};

export default OpenVoucherSuccess;

